<div  class="d-flex justify-content-center" style="padding-top: 40px;">
    <img src="../../../assets/images/work-in-progress.png" width="400" alt="">
   </div>
